import React from 'react';
import loadable from 'react-loadable';

import registerTable from '../../../common/table';

import platformSingleton from '../../platform/platformSingleton';
import { isPlatformApple } from '../../platform/utils/platformDetailsUtils';

import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbar/config/toolbarToolConfig';

const loadTableEditor = () => import(/* webpackChunkName: "tables" */ './module/TableEditor');
const tableEditorLoader = loadable({ loader: loadTableEditor, loading: () => null });

const loadTablePresentation = () => import(/* webpackChunkName: "tables" */ './module/TablePresentationalEditor');
const tablePresentationLoader = loadable({ loader: loadTablePresentation, loading: () => null });

/** Preloads table code during app initialisation, before it is needed by search or editing. */
export const useTableRuntimePreload = () =>
    React.useEffect(() => {
        tableEditorLoader.preload();
        tablePresentationLoader.preload();
    }, []);

const TABLE_CELL_TOOLS = [
    TOOLBAR_TOOLS.TABLE_TEXT_STYLES,
    TOOLBAR_TOOLS.TABLE_CELL_TYPE,
    TOOLBAR_TOOLS.TABLE_CELL_TYPE_FORMAT,
    TOOLBAR_TOOLS.TABLE_CELL_COLOR,
    TOOLBAR_TOOLS.TABLE_CELL_FORMULA,
    TOOLBAR_TOOLS.TABLE_CELL_ALIGNMENT,
    TOOLBAR_TOOLS.TABLE_ADD_COLUMN,
    TOOLBAR_TOOLS.TABLE_ADD_ROW,
    TOOLBAR_TOOLS.TABLE_CONTEXT_MENU,
];

const TABLE_SELECTED_TOOLS = [
    TOOLBAR_TOOLS.LABEL,
    TOOLBAR_TOOLS.REACTION,
    TOOLBAR_TOOLS.COMMENT,
    TOOLBAR_TOOLS.TITLE,
    TOOLBAR_TOOLS.CAPTION,
    ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT,
    ...TOOL_SETS.TRAILING_SELECTED,
];

export default () => {
    return registerTable({
        containerComponent: tableEditorLoader,
        presentationalComponent: tablePresentationLoader,
        tooltip: isPlatformApple(platformSingleton) ? '⌃⌘N' : 'Ctrl+Alt+N',
        tools: {
            selected: TABLE_SELECTED_TOOLS,
            'editing_TABLE-CELL': TABLE_CELL_TOOLS,
            'editing_TABLE-GRID': TABLE_CELL_TOOLS,
            'editing_TABLE-TITLE': [TOOLBAR_TOOLS.TITLE, TOOLBAR_TOOLS.CAPTION],
            editing_CAPTION: TOOL_SETS.TEXT_EDITING_CAPTION,
            'editingRange_TABLE-CELL': [
                TOOLBAR_TOOLS.TEXT_STYLES,
                TOOLBAR_TOOLS.TEXT_BOLD,
                TOOLBAR_TOOLS.TEXT_ITALIC,
                TOOLBAR_TOOLS.TEXT_STRIKETHROUGH,
                TOOLBAR_TOOLS.TEXT_HYPERLINK,
            ],
        },
    });
};
